import { render } from "./EnrolleeEditSpouseOnboardComponent.vue?vue&type=template&id=7e40a463&scoped=true"
import script from "./EnrolleeEditSpouseOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeEditSpouseOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeEditSpouseOnboardComponent.vue?vue&type=style&index=0&id=7e40a463&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e40a463"]])

export default __exports__